import { toSearchUrl } from './searchConditions.js'

export const useItemIndexPageAction = ({
  conditions,
  isFilterOpen,
  searchFromUrl,
  changeSort,
  changeFilters,
  changePage
}) => {
  const getCurrentInputtedKeyword = () =>
    document.querySelector('.search-form__input--text').value
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })
  const updateUrl = () => {
    const url = toSearchUrl(conditions)
    history.pushState(url.split('?')[1] || '', '', url)
  }
  const onPopstate = () => searchFromUrl(location.search, 'browser_history')

  const onSelectSort = async value => {
    scrollToTop()
    await changeSort(value, getCurrentInputtedKeyword())
    updateUrl()
  }

  const onClickPageLink = async page => {
    scrollToTop()
    await changePage(page)
    updateUrl()
  }

  const onSubmitSearchForm = async (
    lowerBudget,
    higherBudget,
    selectedCategoryIds,
    selectedSceneIds,
    selectedReceivingKindIds
  ) => {
    isFilterOpen.value = false
    await changeFilters(
      {
        lowerBudget,
        higherBudget,
        selectedCategoryIds,
        selectedSceneIds,
        selectedReceivingKindIds
      },
      getCurrentInputtedKeyword()
    )
    updateUrl()
  }

  // 選択中のチップの再タップは解除（価格条件をクリア）。他の絞り込み条件は維持する。
  // ページ全体を再読み込みして遷移する（pushState は使わない）。
  const onClickBudgetChip = ({ lowerBudget, higherBudget }) => {
    const isSelected =
      conditions.lowerBudget === lowerBudget &&
      conditions.higherBudget === higherBudget
    // 検索条件（キーワードなど）はイベントに付けず、URLのクエリから取る。
    dataLayer.push({
      event: 'click_item_list__budget_chip',
      lower_budget: lowerBudget,
      higher_budget: higherBudget,
      budget_action: isSelected ? 'deselect' : 'select'
    })
    const url = toSearchUrl({
      ...conditions,
      lowerBudget: isSelected ? null : lowerBudget,
      higherBudget: isSelected ? null : higherBudget,
      keyword: getCurrentInputtedKeyword(),
      currentPage: 1
    })
    // 遷移後の search イベントに via を載せるため、URL のクエリで渡す。
    location.href = `${url}${url.includes('?') ? '&' : '?'}via=budget_chip`
  }

  const onClickItem = ({ id, itemSkuId }, rank) => {
    dataLayer.push({
      event: 'click_item_list__item_detail',
      item_id: id,
      item_sku_id: itemSkuId,
      rank,
      sort_key: conditions.sortSelectedValue,
      lower_budget: conditions.lowerBudget,
      higher_budget: conditions.higherBudget,
      scene_id: conditions.selectedSceneIds.join(','),
      category_id: conditions.selectedCategoryIds.join(','),
      item_receiving_kinds: conditions.selectedReceivingKindIds.join(','),
      keyword: conditions.keyword
    })
  }

  const onClickItemBox = itemId => {
    dataLayer.push({
      event: 'click_view_history__item',
      via: 'item_list',
      item_id: itemId
    })
  }

  const onClickSectionHeaderLink = () => {
    dataLayer.push({ event: 'click_item_list__view_history_list' })
  }

  return {
    getCurrentInputtedKeyword,
    onPopstate,
    onSelectSort,
    onClickPageLink,
    onSubmitSearchForm,
    onClickBudgetChip,
    onClickItem,
    onClickItemBox,
    onClickSectionHeaderLink
  }
}
